exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n@media screen and (max-width: 1024px) {\r\n    .author-thumb img {\r\n        height: 45px !important;\r\n        width: 45px !important;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/userlist-item/userlist-item.component.css
// module id = ../../../../../src/app/userlist-item/userlist-item.component.css
// module chunks = main